import { useParams, useNavigate } from "react-router-dom";
import { useGameData } from "./hooks/use-game-data";
import { GameHeader } from "./components/game-header/game-header";
import { KPIChips } from "./components/kpi-chips/kpi-chips";
import { WinExpectancyChart } from "./components/win-expectancy-chart/win-expectancy-chart";
import { GameLog } from "./components/game-log/game-log";
import { GameLineups } from "./components/game-lineups/game-lineups";
import { LoadingState, ErrorState } from "../../components/shared/page-states/page-states";

export const GamePage = () => {
  const { year, gameId } = useParams();
  const navigate = useNavigate();
  const { gameData, loading, error } = useGameData(year, gameId);

  const handleBack = () => {
    if (gameData?.game_date) {
      navigate(`/scoreboard?date=${gameData.game_date}&division=${gameData.division}`);
    } else {
      navigate("/scoreboard");
    }
  };

  if (loading) return <LoadingState />;
  if (error) return <ErrorState error={error} title="Error Loading Game" />;
  if (!gameData) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      <div className="relative z-10 container max-w-6xl mx-auto px-8 sm:px-12 lg:px-16 py-16">
        <GameHeader gameData={gameData} onBack={handleBack} />
        <KPIChips gameData={gameData} />

        <div className="space-y-4">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <WinExpectancyChart
              homeTeam={gameData.home_team}
              awayTeam={gameData.away_team}
              plays={gameData.plays || []}
            />
          </div>

          <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl shadow-sm border border-gray-200">
            <GameLog
              plays={gameData.plays || []}
              homeTeam={gameData.home_team}
              awayTeam={gameData.away_team}
            />
          </div>

          <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl shadow-sm border border-gray-200">
            <GameLineups
              battingLineups={gameData.batting_lineups || []}
              pitchingLineups={gameData.pitching_lineups || []}
              homeTeam={gameData.home_team}
              awayTeam={gameData.away_team}
              homeTeamId={gameData.home_team_id}
              awayTeamId={gameData.away_team_id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
